import React from 'react';

const DEFAULT_LABEL = '★ Most Popular';

const POSITION_CLASSES = {
  'top-center': '-top-3 left-1/2 -translate-x-1/2',
  'top-right': '-top-3 right-4',
  'top-left': '-top-3 left-4',
};

export function RecommendedTag({
  label = DEFAULT_LABEL,
  position = 'top-center',
  className = '',
}) {
  return (
    <span
      className={`absolute z-10 whitespace-nowrap rounded-full bg-v5-yellow-200 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-v5-neutral-600 shadow-md ${
        POSITION_CLASSES[position] || POSITION_CLASSES['top-center']
      } ${className}`}
    >
      {label}
    </span>
  );
}

export function FeaturedCard({
  recommended = false,
  tagLabel = DEFAULT_LABEL,
  tagPosition = 'top-center',
  className = '',
  children,
  ...rest
}) {
  // `!border-v5-green-300` uses Tailwind's important modifier so the accent
  // border wins over whatever border-color the caller passed via `className`
  // (same-property conflicts resolve by CSS source order, not class order).
  const emphasis = recommended
    ? '!border-v5-green-300 bg-v5-green-200/5 shadow-lg shadow-v5-green-200/30'
    : '';

  return (
    <div className={`relative transition-all duration-300 ${className} ${emphasis}`} {...rest}>
      {recommended && (
        <RecommendedTag label={tagLabel} position={tagPosition} />
      )}
      {children}
    </div>
  );
}

export default FeaturedCard;
